import { createMiddleware, createStart } from '@tanstack/react-start';
import { log_error } from '@photology/cloudflare';

declare module '@tanstack/react-start' {
	interface Register {
		server: {
			requestContext: {
				// future custom properties
			};
		};
	}
}

const sentry = createMiddleware().server(async ({ next }) => {
	try {
		return await next();
	} catch (ex) {
		if (ex instanceof Error || typeof ex === 'string') {
			log_error(ex);

			return new Response('Internal Server Error', { status: 500 });
		}

		throw ex;
	}
});

export const startInstance = createStart(() => {
	return {
		defaultSsr: true,
		requestMiddleware: [sentry],
	};
});
